var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMisionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30",
    "data-name": "Group 30",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.565,
    height: 94.009,
    viewBox: "0 0 86.565 94.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(19.515 18.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M3071.125,1818.865H3047.35a1.444,1.444,0,0,1,0-2.889h23.775a1.444,1.444,0,0,1,0,2.889Z",
    transform: "translate(-3035.47 -1757.285)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M3097.8,1888.427h-19.445a1.444,1.444,0,1,1,0-2.889H3097.8a1.444,1.444,0,1,1,0,2.889Z",
    transform: "translate(-3064.315 -1821.991)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M2961.773,1018.329a21.844,21.844,0,0,1-2.731,10.675c-2.752,4.86-5.089,12.938-6.139,18.442a21.874,21.874,0,0,1-.625,2.646h-25.666a26.316,26.316,0,0,1-.745-3.367c-.713-3.868-2.281-10.441-4.036-13.942-1.086-2.166-2.375-4.236-3.242-6.507a22.323,22.323,0,1,1,43.184-7.947Z",
    transform: "translate(-2915.684 -994.564)",
    fill: "#4a8b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M2933.035,1032.293h-25.666a1.444,1.444,0,0,1-1.374-1,23.367,23.367,0,0,1-.71-3.1c-.028-.155-.055-.307-.082-.454-.624-3.385-2.149-10.049-3.907-13.557-.343-.684-.719-1.38-1.082-2.053a38.991,38.991,0,0,1-2.218-4.586,23.767,23.767,0,1,1,45.978-8.462,23.141,23.141,0,0,1-2.918,11.386c-2.636,4.655-4.946,12.594-5.977,18a23.252,23.252,0,0,1-.67,2.822A1.444,1.444,0,0,1,2933.035,1032.293Zm-24.566-2.889h23.468c.119-.5.216-1.007.3-1.473,1.11-5.82,3.489-13.917,6.3-18.883a20.534,20.534,0,0,0,2.543-9.963,20.878,20.878,0,1,0-40.391,7.431,36.26,36.26,0,0,0,2.062,4.245c.373.692.759,1.407,1.122,2.13,1.9,3.8,3.514,10.793,4.165,14.327q.042.227.085.466C2908.226,1028.232,2908.333,1028.823,2908.469,1029.4Z",
    transform: "translate(-2896.44 -975.32)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M3306.884,1092.995a1.444,1.444,0,0,1-1.443-1.4c-.282-8.549-9.586-12.522-9.68-12.561a1.444,1.444,0,0,1,1.1-2.67,22.465,22.465,0,0,1,5.563,3.561,15.912,15.912,0,0,1,5.9,11.574,1.444,1.444,0,0,1-1.4,1.491Z",
    transform: "translate(-3267.055 -1069.211)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M3119.059,1961.33c0,3.673-4.28,6.651-9.559,6.651s-9.56-2.978-9.56-6.651a.147.147,0,0,1,0-.023h19.117C3119.059,1961.314,3119.059,1961.323,3119.059,1961.33Z",
    transform: "translate(-3085.733 -1892.47)",
    fill: "#525252"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M3219.592,725.247a1.3,1.3,0,0,1-1.3-1.3V711.662a1.3,1.3,0,1,1,2.593,0v12.289A1.3,1.3,0,0,1,3219.592,725.247Z",
    transform: "translate(-3176.31 -710.366)",
    fill: "#525252"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 39.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M3657.252,1275.914h-12.288a1.3,1.3,0,1,1,0-2.593h12.288a1.3,1.3,0,1,1,0,2.593Z",
    transform: "translate(-3571.984 -1273.321)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M2630.5,1275.914h-12.289a1.3,1.3,0,1,1,0-2.593H2630.5a1.3,1.3,0,1,1,0,2.593Z",
    transform: "translate(-2616.912 -1273.321)",
    fill: "#525252"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M2747.938,923.594a1.291,1.291,0,0,1-.8-.274l-9.689-7.559a1.3,1.3,0,1,1,1.595-2.044l9.689,7.558a1.3,1.3,0,0,1-.8,2.318Z",
    transform: "translate(-2728.573 -899.264)",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M3545.433,923.594a1.3,1.3,0,0,1-.8-2.319l9.689-7.559a1.3,1.3,0,1,1,1.595,2.044l-9.689,7.558A1.291,1.291,0,0,1,3545.433,923.594Z",
    transform: "translate(-3479.401 -899.265)",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M3581.132,1530.093a1.292,1.292,0,0,1-.8-.274l-9.689-7.559a1.3,1.3,0,0,1,1.595-2.044l9.689,7.558a1.3,1.3,0,0,1-.8,2.319Z",
    transform: "translate(-3503.597 -1463.421)",
    fill: "#525252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M2721.529,1530.092a1.3,1.3,0,0,1-.8-2.319l9.689-7.558a1.3,1.3,0,1,1,1.595,2.044l-9.689,7.559A1.292,1.292,0,0,1,2721.529,1530.092Z",
    transform: "translate(-2713.018 -1463.42)",
    fill: "#525252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M3229.576,1038.181a20.9,20.9,0,0,1-2.612,10.21c-2.633,4.649-4.869,12.377-5.873,17.641a21.084,21.084,0,0,1-.6,2.531H3218a21.1,21.1,0,0,0,.6-2.531c1-5.264,3.238-12.992,5.872-17.641a20.9,20.9,0,0,0,2.612-10.21c0-11.374-9.111-20-20.324-20.648.412-.024,1.013-.113,1.432-.113C3219.985,1017.42,3229.576,1026.389,3229.576,1038.181Z",
    transform: "translate(-3165.579 -995.983)",
    fill: "#3d7221"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisionIcon);
export default __webpack_public_path__ + "static/media/mision-icon.6ca00306d35f8b28e67b7fa0ffcc2288.svg";
export { ForwardRef as ReactComponent };